// Applies the corporate-design profile delivered by GET /api/company to the
// document: CSS custom properties (colours incl. derived hover/active
// shades), the data-brand attribute, the favicon and the page title.
// Colour roles follow the CD manual (documentation/CD-Manual_CHL-Merick-CSL-CAL_v2.pdf).

function hexToRgb (hex) {
  const value = hex.replace('#', '')
  if (!/^[0-9a-fA-F]{6}$/.test(value)) return null
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16)
  }
}

// Mix a hex colour towards black, factor 0..1 (SCSS darken() equivalent-ish)
function shade (hex, factor) {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex
  const mix = (c) => Math.max(0, Math.round(c * (1 - factor)))
  return `rgb(${mix(rgb.r)}, ${mix(rgb.g)}, ${mix(rgb.b)})`
}

function alpha (hex, a) {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`
}

export function applyBrandTheme (company) {
  if (!company) return
  const root = document.documentElement

  if (company.brand) {
    root.setAttribute('data-brand', company.brand)
  }

  const theme = company.theme || {}
  const set = (name, value) => { if (value) root.style.setProperty(name, value) }

  if (theme.signature) {
    set('--cd-signature', theme.signature)
    set('--cd-signature-hover', shade(theme.signature, 0.10))
    set('--cd-signature-active', shade(theme.signature, 0.18))
    set('--cd-signature-shadow', alpha(theme.signature, 0.4))
  }
  if (theme.accent) {
    set('--cd-accent', theme.accent)
    set('--cd-accent-shadow', alpha(theme.accent, 0.25))
  }
  set('--cd-primary', theme.primary)
  set('--cd-navy', theme.navy)
  set('--cd-alert', theme.alert)
  set('--cd-text', theme.text)
  set('--cd-section-bg', theme.sectionBg)
  set('--cd-line', theme.line)
  set('--cd-caption', theme.caption)

  if (company.favicon) {
    document.querySelectorAll('link[rel="icon"]').forEach((link) => {
      link.type = 'image/png'
      link.href = '/' + company.favicon
    })
  }

  if (company.name) {
    document.title = company.name + ' · Facility Monitoring'
  }
}
